import React from 'react';
import { Card, CardBody, CardFooter, Col, Row } from 'reactstrap';
import { H4, H6, H5, Image } from '../../../AbstractElements';
import { Likes, Posts } from '../../../Constant';
import { SocialCard } from '../../../Data/Widgets/general';
import CountUp from 'react-countup';

const SocialWidgetCard = () => {
  return (
    <Col xl='6' lg='12'>
      <Row>
        {SocialCard.map((item, i) => (
          <Col key={i} sm='6'>
            <Card className='social-widget-card'>
              <CardBody>
                <div className='d-flex'>
                  <div className='social-font flex-shrink-0'>
                    <Image src={item.image} alt={item.title} />
                  </div>
                  <div className='flex-grow-1'>
                    <H4>{item.title}</H4>
                  </div>
                </div>
              </CardBody>
              <CardFooter>
                <Row>
                  <Col className='text-center'>
                    <H6 className='font-roboto'>{Posts}</H6>
                    <H5 className='counter mb-0 font-roboto font-primary mt-1'>
                      <CountUp end={item.post} />
                    </H5>
                  </Col>
                  <Col className='text-center'>
                    <H6 className='font-roboto'>{Likes}</H6>
                    <H5 className='counter mb-0 font-roboto font-primary mt-1'>
                      <CountUp end={item.like} />
                    </H5>
                  </Col>
                </Row>
              </CardFooter>
            </Card>
          </Col>
        ))}
      </Row>
    </Col>
  );
};

export default SocialWidgetCard;
